module.exports = __webpack_public_path__ + "img/equip-middle-two.2c087308.png";